import React, { Component } from "react";

import { Media } from "./Media";
import { PlayerProps } from "./properties";
import { Timeline } from "./Timeline";
import { Toolbar } from "./Toolbar";

import styles from "./index.module.css";

interface YacastPlayerState {
    currentTime: Date;
    start: Date;
    musicZoom: number;
}

export class YacastPlayer extends Component<PlayerProps, YacastPlayerState> {
    private autoplay: boolean = false;
    private endReachedTimer: number = 0;
    private pauseAt: Date | undefined = undefined;
    private timeline: Timeline | null = null;

    public constructor(props: PlayerProps) {
        super(props);
        this.state = {
            currentTime: props.start,
            start: props.start,
            musicZoom: 1,
        };
        this.autoplay = props.autoplay === true;
    }

    public render() {
        return (
            <div className={styles.container}>
                <Media
                    aclToken={this.props.aclToken}
                    autoplay={this.autoplay}
                    exposeMedia={this.props.exposeMedia}
                    onPlayPause={this.props.onPlayPause}
                    onTimeUpdate={this.onTimeUpdate.bind(this)}
                    pauseAt={this.pauseAt}
                    playerProps={this.props}
                    shareToken={this.props.shareToken}
                    start={this.state.start}
                    streamerURL={this.props.streamerURL}
                    onSelectTimeChange={this.props.onSelectTimeChange}
                    key={this.state.start.getTime()}
                />
                <Timeline
                    currentTime={this.state.currentTime}
                    onEndReach={this.onEndReach.bind(this)}
                    onSetStart={this.onSetStart.bind(this)}
                    playerProps={this.props}
                    ref={(ref) => (this.timeline = ref)}
                    updateZoom={this.updateZoom}
                />
                {this.props.lightPlayer ? (
                    ""
                ) : (
                    <Toolbar
                        onChangeZoom={this.onChangeZoom.bind(this)}
                        onCenter={this.onCenter.bind(this)}
                        onPlaySelection={this.onPlaySelection.bind(this)}
                        playerProps={this.props}
                    />
                )}
            </div>
        );
    }

    private onChangeZoom(zoom: number) {
        if (this.timeline !== null) {
            this.timeline.setZoom(zoom);
        }
    }

    private onCenter() {
        if (this.timeline !== null) {
            this.timeline.center();
        }
    }

    private onTimeUpdate(currentTime: Date) {
        this.setState({ currentTime: currentTime });

        if (typeof this.props.onDateUpdate !== "undefined") {
            this.props.onDateUpdate(currentTime);
        }
    }

    private onSetStart(start: Date, pauseAt?: Date) {
        this.pauseAt = pauseAt;
        this.setState({
            start: start,
        });
    }

    public updateSelection = (start: Date, end: Date) => {
        if (this.timeline) {
            this.timeline.updateSelection(start, end);
        }
    };

    private onEndReach() {
        if (this.endReachedTimer === 0) {
            this.endReachedTimer = window.setTimeout(() => {
                this.endReachedTimer = 0;
            }, 1000);
            this.autoplay = false;
            this.setState({
                start: this.props.start,
            });
        }
    }
    private updateZoom = (value: number) => {
        this.setState({ musicZoom: value });
    };
    /*
    private onPlayPause(playing: boolean) {
        this.autoplay = playing;
    }*/

    private onPlaySelection(): void {
        if (
            typeof this.props.selectionStart === "undefined" ||
            typeof this.props.selectionEnd === "undefined"
        ) {
            return;
        }
        this.autoplay = true;
        this.onSetStart(
            new Date(this.props.selectionStart),
            new Date(this.props.selectionEnd)
        );
    }
}
